import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../../cache/CacheKeys'
import CacheManager from '../../../cache/CacheManager'
import GeneralTokenListPageUI from './GeneralTokenListPageUI'

class GeneralTokenListPageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      errorList: null,
      loan: null,
      directorList: null,
      propertyList: null,
      allPropertyList: null,
      selectedDocType: 'all',
    }

    this.docTypeOptions = [
      { value: 'loan_agreement', label: 'Loan agreement' },
      { value: 'escrow_agreement', label: 'Escrow agreement' },
      { value: 'pledge', label: 'Pledge' },
      { value: 'ndu', label: 'NDU' },
      { value: 'personal_guarantee', label: 'Personal guarantee' },
      { value: 'all', label: 'All' },
    ]
  }

  render() {
    return (
      <GeneralTokenListPageUI
        context={this.props.context}
        errorList={this.state.errorList}
        loan={this.state.loan}
        directorList={this.state.directorList}
        propertyList={this.state.propertyList}
        selectedDocType={this.state.selectedDocType}
        docTypeOptionList={this.docTypeOptions}
        onDocTypeChange={this.onDocTypeChange}
        onRefreshClick={this.onRefreshClick}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getLoan(context)
    this.getDirectors(context)
    this.getProperties(context)
  }

  getLoan(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/loans/${this.props.match.params.loanId}`,
      cacheKey: CacheKeys.Loan(this.props.match.params.loanId),
      callback: this.getLoanCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getLoanCallback = (response) => {
    this.setState({ errorList: response.errorList, loan: response.loan })
  }

  getDirectors(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/loans/${this.props.match.params.loanId}/users`,
      cacheKey: CacheKeys.LoanDirectors(this.props.match.params.loanId),
      callback: this.getDirectorsCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getDirectorsCallback = (response) => {
    this.setState({ errorList: response.errorList, directorList: response.accountUserList })
  }

  getProperties(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/loans/${this.props.match.params.loanId}/properties`,
      cacheKey: CacheKeys.LoanProperties(this.props.match.params.loanId),
      callback: this.getPropertiesCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getPropertiesCallback = (response) => {
    let filtersStr = sessionStorage.getItem(CacheKeys.TokenDocTypeFilter(this.props.match.params.loanId))
    let selectedDocType = filtersStr ? JSON.parse(filtersStr) : 'all'
    const allProperties = response.loanPropertyList || []
    this.setState({
      errorList: response.errorList,
      allPropertyList: allProperties,
      selectedDocType,
      propertyList: this.filterByDocType(allProperties, selectedDocType),
    })
  }

  filterByDocType = (loanPropertyList, selectedDocType) => {
    if (!loanPropertyList) {
      return loanPropertyList
    }
    if (!selectedDocType || selectedDocType === 'all') {
      return loanPropertyList
    }
    return loanPropertyList.filter((property) => {
      const docTypes = property.loanDocTypes || []
      return docTypes.includes(selectedDocType)
    })
  }

  onDocTypeChange = (selectedDocType) => {
    const value = selectedDocType || 'all'
    sessionStorage.setItem(CacheKeys.TokenDocTypeFilter(this.props.match.params.loanId), JSON.stringify(value))
    this.setState((prevState) => ({
      selectedDocType: value,
      propertyList: this.filterByDocType(prevState.allPropertyList, value),
    }))
  }

  onRefreshClick = (noBusy) => {
    let loan = this.state.loan
    let context = this.props.context
    CacheManager.removeObject(CacheKeys.Loan(loan.loanId))
    CacheManager.removeObject(CacheKeys.LoanDirectors(loan.loanId))
    CacheManager.removeObject(CacheKeys.LoanProperties(loan.loanId))
    if (noBusy === 'noBusy') {
      this.getProperties(context)
      this.getDirectors(context)
    }
    else {
      this.setState({
        loan: null,
        errorList: null,
      })
      this.getLoan(context)
      this.getDirectors(context)
      this.getProperties(context)
    }
  }
}

export default withRouter(GeneralTokenListPageSF)
